import { treatmyutiCommonEnvironment } from '@environments/treatmyuti/environment.common';
import { AppEnvironment } from '@models/app-environment';

/**
 * Environment variables for use on the TreatMyUTI.com site, in production environment.
 */
export const environment: AppEnvironment = {
  ...treatmyutiCommonEnvironment,
  production: true,
  apiUrl: 'https://api.analytecare.com',
  analyteCareApi: 'https://api.analytecare.com',
  googleMapApiKey: 'AIzaSyDIEZHrvUCVq39wvL0mBOanghqkHIk8cRE',
  braintreeToken: 'production_csgfcd5t_53b8hvj83v98kzmr',
  googlePay: {
    merchantId: 'BCR2DN4TQ3K3DXR3',
    apiVersion: 2,
    apiVersionMinor: 0,
  },
  defaultOrderLabId: '27349',
  oncehubSchedulingUrl: 'https://go.oncehub.com',
  siteUrls: {
    home: 'https://treatmyuti.com',
    termsOfService: 'https://treatmyuti.com/terms-of-service/',
    myAccount: 'https://my-account.treatmyuti.com',
    tests: 'https://treatmyuti.com/antibiotics/',
    notFound: 'https://treatmyuti.com/404',
  },
};
